const state = {
  unidades: [],
};

function getHierarquia(unidadeId, todasUnidades, resultado) {
  const unidade = todasUnidades.find((u) => u.idVersao === unidadeId);
  if (unidade) {
    resultado.push(unidade);
    if (unidade.subunidades.length > 0) {
      unidade.subunidades.forEach((u) => getHierarquia(u.idVersao, todasUnidades, resultado));
    }
    return resultado.sort((a, b) => a.sigla.localeCompare(b.sigla));
  }
  return [];
}

function getHierarquiaMapeamento(unidadeId, todasUnidades, resultado) {
  const unidade = todasUnidades.find((u) => u.idVersao === unidadeId);
  if (unidade) {
    resultado.push(unidade);
    if (unidade.subunidades.length > 0) {
      unidade.subunidades.forEach((u) => getHierarquia(u.idVersao, todasUnidades, resultado));
    }
    return resultado;
  }
  return [];
}

const actions = {
  setUnidades({ commit }, unidades) {
    return new Promise((resolve) => {
      commit('SET_UNIDADES', unidades);
      resolve();
    });
  },
};

const getters = {
  getUnidades: (st, gt, rootState) => (request = {}) => {
    if (!request.unidadePaiId) {
      request.unidadePaiId = rootState.mapeamento.usuarioMapeamento.unidade.idVersao;
    }
    return request.somenteSubunidades
      ? st.unidades.filter((u) => u.unidadePai && u.unidadePai.idVersao === request.unidadePaiId)
      : getHierarquia(request.unidadePaiId, st.unidades, []);
  },
  getUnidadesHierarquia: (st, gt) => (unidadePaiId) => {
    const request = {
      unidadePaiId,
    };
    return gt.getUnidades(request);
  },

  getUnidadesMapeamento: (st, gt, rootState) => (request = {}) => {
    const { mapeamento } = request;
    const unidadesMapeamento = mapeamento ? [mapeamento.unidade, ...mapeamento.unidades] : [];

    if (!request.unidadePaiId) {
      const unidadePai = unidadesMapeamento.find((u) => u.id === rootState.auth.unidade.id);
      request.unidadePaiId = unidadePai ? unidadePai.idVersao : -1;
    }

    const resultado = request.somenteSubunidades
      ? unidadesMapeamento.filter((u) => u.unidadePai && u.unidadePai.idVersao === request.unidadePaiId)
      : getHierarquiaMapeamento(request.unidadePaiId, unidadesMapeamento, []);

    return resultado.sort((a, b) => a.sigla.localeCompare(b.sigla));
  },
  getUnidadesByGestor: (st, gt, rootState) => (request = {}) => {
    const mapeamento = request.mapeamento ? request.mapeamento : rootState.mapeamento.mapeamento;
    return gt.getUnidadesMapeamento({ ...request, mapeamento });
  },
  getUnidadesByAcesso: (st, gt, rootState) => (acesso, mapeamentoId) => {
    let mapeamento;
    if (acesso === 'COMISSAO') {
      mapeamento = rootState.mapeamento.mapeamentosComissao.find((m) => m.id === mapeamentoId);

      return gt.getUnidadesMapeamento({ unidadePaiId: mapeamento.unidade.idVersao, mapeamento });
    }
    mapeamento = rootState.mapeamento.mapeamentos.find((m) => m.id === mapeamentoId);
    return gt.getUnidadesMapeamento({ mapeamento });
  },
};

const mutations = {
  SET_UNIDADES(st, unidades) {
    st.unidades = unidades.sort((a, b) => a.sigla.localeCompare(b.sigla));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
